import React from 'react';

const ProfileMenu = ({
  user,
  handleLogout,
  navigate,
  language = 'th',
  onLanguageChange // ← Receive the callback properly
}) => {
  const translations = {
    th: {
      profile: 'ข้อมูลส่วนตัว',
      changePassword: 'เปลี่ยนรหัสผ่าน',
      managePosts: 'จัดการโพสต์',
      language: 'ภาษา',
      logout: 'ออกจากระบบ'
    },
    en: {
      profile: 'Profile Information',
      changePassword: 'Change Password',
      managePosts: 'Manage Posts',
      language: 'Language',
      logout: 'Logout'
    },
    zh: {
      profile: '个人资料',
      changePassword: '更改密码',
      managePosts: '管理帖子',
      language: '语言',
      logout: '退出登录'
    }
  };

  const roleLabel = (role) => {
    if (role === 'venue_owner') return language === 'en' ? 'Business Owner' : language === 'zh' ? '商家' : 'จัดการข้อมูลธุรกิจ';
    if (role === 'artist') return language === 'en' ? 'Artist' : language === 'zh' ? '艺术家' : 'ศิลปิน';
    if (role === 'admin') return language === 'en' ? 'Admin' : language === 'zh' ? '管理员' : 'ผู้ดูแลระบบ';
    return language === 'en' ? 'User' : language === 'zh' ? '用户' : 'ผู้ใช้';
  };

  const t = translations[language];

  const handleLanguageChange = (e) => {
    const newLanguage = e.target.value;
    // FIX: Use the callback passed from parent instead of context
    if (onLanguageChange) {
      onLanguageChange(newLanguage);
    }
  };

  return (
    <div className="profile-menu">
      {/* Profile Header */}
      <div className="profile-header">
        {user.avatar_url ? (
          <img 
            src={user.avatar_url} 
            alt="Profile" 
            className="profile-menu-image" 
          />
        ) : (
          <div className="profile-menu-avatar-fallback">
            <span className="avatar-letter">{user.name ? user.name.charAt(0).toUpperCase() : 'U'}</span>
          </div>
        )}
        <div className="profile-user-info">
          <h3>{user.name}</h3>
          <p>{user.email}</p>
        </div>
      </div>

      {/* Menu Items */}
      <ul>
        <li onClick={() => navigate('/profile')} style={{ cursor: 'pointer', justifyContent: 'space-between' }}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <i className="fas fa-user"></i> {t.profile}
          </span>
          <span style={{
            fontSize: '0.7rem',
            background: '#4a6cf7',
            color: '#fff',
            borderRadius: '10px',
            padding: '2px 8px',
            marginLeft: '8px',
            fontWeight: 600,
            whiteSpace: 'nowrap'
          }}>
            {roleLabel(user.role)}
          </span>
        </li>

        <li onClick={() => navigate('/change-password')}>
          <i className="fas fa-key"></i> {t.changePassword}
        </li>

        {user.role === 'venue_owner' && (
          <li onClick={() => navigate('/venue/dashboard')} style={{ cursor: 'pointer' }}>
            <i className="fas fa-store"></i>
            {language === 'zh' ? '商家管理' : language === 'en' ? 'Business Dashboard' : 'จัดการข้อมูลธุรกิจ'}
          </li>
        )}

        <li onClick={() => navigate('/manage-posts')} style={{ cursor: 'pointer' }}>
          <i className="fas fa-edit"></i> {t.managePosts}
        </li>

        {/* Language Selection */}
        <li className="language-item">
          <i className="fas fa-language"></i>
          <span>{t.language}</span>
          <select 
            className="language-select"
            value={language}
            onChange={handleLanguageChange}
            onClick={(e) => e.stopPropagation()}
          >
            <option value="th">ไทย</option>
            <option value="en">English</option>
            <option value="zh">中文</option>
          </select>
        </li>
        
        <li className="logout-item" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i> {t.logout}
        </li>
      </ul>
    </div>
  );
};

export default ProfileMenu;